// extracted by mini-css-extract-plugin
export default {"player":"yKrd2V","playerWrapper":"CCb75L","overlay":"rjQ1C9","hidden":"DGOF5A","fillAllSpace":"pZtBOu"};